import { render, staticRenderFns } from "./PricingRulesDailyPrices.vue?vue&type=template&id=af46bb46"
import script from "./PricingRulesDailyPrices.vue?vue&type=script&lang=js"
export * from "./PricingRulesDailyPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports